import React from "react";
import { useLists } from "../../context/listContext";
import { useEffect } from "react";
import { useAuth } from "../../context/authContext";
import { useLocation, useNavigate } from "react-router-dom";
import { convertToRupee } from "../../utils/number-conversions";
import { Button } from "@mui/material";
// import { Button, FormGroup } from "@mui/material";

export const OrderDetails = () => {
  const location = useLocation();
  const { fetchOrdersList, ordersList } = useLists();
  const navigate = useNavigate();
  useEffect(() => {
    fetchOrdersList(location.state.data.order_id);
  }, []);
  // console.log(ordersList[0]);
  return (
    <>
      <Button
        onClick={() => {
          localStorage.setItem("orderDetails", JSON.stringify(ordersList[0]))
          navigate("/billing", {
          state: {
            data: ordersList[0]
          }
        })}}
      >
        Print Me
      </Button>
      <div className="w-[90%] mx-auto pt-5">
        {/* <div className=" text-center">
      <p className="my-5 p-5 border-dashed border-2 border-[#f07950] text-2xl">
        Thank you. Your order has been received.
      </p>
    </div> */}
        <div className="my-5">
          <p className=" text-2xl text-[#1976d2] my-2">
            User Name:{" "}
            {`${ordersList[0]?.user?.first_name} ${ordersList[0]?.user?.last_name}`}
          </p>
          <table className="w-full">
            <thead>
              <tr className="text-left">
                <th className="font-medium text-sm text-[#1976d2]">
                  Order Id:
                </th>
                <th className="font-medium text-sm text-[#1976d2]">Date</th>
                <th className="font-medium text-sm text-[#1976d2]">Email</th>
                <th className="font-medium text-sm text-[#1976d2]">Total</th>
                <th className="font-medium text-sm text-[#1976d2]">
                  Payment Method
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border-b-2 py-5">{ordersList[0]?.order_id}</td>
                <td className="border-b-2 py-5">
                  {" "}
                  {new Date(
                    ordersList[0]?.createdAt?.slice(0, -5)
                  )?.toDateString()}
                </td>
                <td className="border-b-2 py-5">
                  {" "}
                  {ordersList[0]?.user?.email}
                </td>
                <td className="border-b-2 py-5">
                  {convertToRupee(ordersList[0]?.order_subtotal)}
                </td>
                <td className="border-b-2 my-5">
                  <strong>{ordersList[0]?.payment_method}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="my-5">
          <h2 className="font-bold text-xl">ORDER DETAILS</h2>
          <div className="my-5">
            <table className="w-full">
              <thead>
                <tr>
                  <td>
                    <strong>PRODUCT</strong>
                  </td>
                  <td className="text-right">
                    <strong>TOTAL</strong>
                  </td>
                </tr>
              </thead>
              <tbody>
                {ordersList[0]?.cart?.cartitems?.map((item, i) => {
                  return (
                    <tr className="" key={i}>
                      <td className="py-3 border-b-2 flex items-center">
                        <img
                          className="w-[15rem] mr-auto flex"
                          src={item?.product?.product_image_file}
                          alt={item?.product?.product_image_name}
                        />
                        {item?.product?.product_name} × {item?.product_quantity}
                      </td>
                      <td className="text-right py-3 border-b-2">
                        <strong>
                          {convertToRupee(
                            item?.product?.product_price *
                              item?.product_quantity
                          )}
                        </strong>
                      </td>
                    </tr>
                  );
                })}
                {/* <tr className="">
              <td className="py-3 border-b-2">
                Augue adipiscing euismod × 1
              </td>
              <td className="text-right py-3 border-b-2">
                <strong>₹199.00</strong>
              </td>
            </tr> */}
                <tr className="">
                  <td className="py-3 border-b-2">
                    <strong>Subtotal:</strong>
                  </td>
                  <td className="text-right py-3 border-b-2">
                    <strong>
                      {convertToRupee(ordersList[0]?.order_subtotal)}
                    </strong>
                  </td>
                </tr>
                <tr className="">
                  <td className="py-3 border-b-2">
                    <strong>Shipping:</strong>
                  </td>
                  <td className="text-right py-3 border-b-2">Free shipping</td>
                </tr>
                <tr className="">
                  <td className="py-3 border-b-2">
                    <strong>Payment method:</strong>
                  </td>
                  <td className="text-right py-3 border-b-2">
                    {ordersList[0]?.payment_method}
                  </td>
                </tr>
                <tr className="">
                  <td className="py-3 border-b-2">
                    <strong>Total: </strong>
                  </td>
                  <td className="text-right py-3 border-b-2">
                    <strong>
                      {convertToRupee(ordersList[0]?.order_subtotal)}
                    </strong>
                  </td>
                </tr>
                {/* <tr className="">
              <td className="py-3 border-b-2 text-2xl">
                <strong>Note:</strong>
              </td>
              <td className="text-right py-3 border-b-2">Test</td>
            </tr> */}
              </tbody>
            </table>
          </div>
          <div className="flex flex-wrap justify-between items-between">
            <div>
              <h3 className="text-xl font-bold">BILLING ADDRESS</h3>
              <p>{ordersList[0]?.address?.address_name}</p>
              <p>{ordersList[0]?.address?.full_name}</p>
              <p>{ordersList[0]?.address?.society}</p>
              <p>
                {ordersList[0]?.address?.city}{" "}
                {ordersList[0]?.address?.postal_code}
              </p>
              <p>{ordersList[0]?.address?.state}</p>
              <p>{ordersList[0]?.address?.mobile_no}</p>
              <p>{ordersList[0]?.address?.email}</p>
            </div>
            <div>
              <h3 className="text-xl font-bold">SHIPPING ADDRESS</h3>
              <p>{ordersList[0]?.address?.address_name}</p>
              <p>{ordersList[0]?.address?.full_name}</p>
              <p>{ordersList[0]?.address?.society}</p>
              <p>
                {ordersList[0]?.address?.city}{" "}
                {ordersList[0]?.address?.postal_code}
              </p>
              <p>{ordersList[0]?.address?.state}</p>
              <p>{ordersList[0]?.address?.mobile_no}</p>
              <p>{ordersList[0]?.address?.email}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
